<template>
    <div class="mail-chat-container">
        <div v-if="showMessageList" class="message-list">
            <div class="message-list-header">
                <p class="message-title">Messages</p>
                <i @click="filterMessages" class="fas fa-filter"></i>
                <div v-if="showFilterContainer" class="filter-box">
                    <p
                        @click="getFilterByValue(filter)"
                        v-for="(filter, index) in filterBy"
                        :key="index"
                        class="filter-option"
                        :class="filterByValue === filter ? 'select-filter' : ''"
                    >
                        {{ filter }}
                    </p>
                </div>
            </div>
            <div v-if="allMails.length" class="message-list-content">
                <div
                    v-for="(mail, index) in allMails"
                    :key="index"
                    :class="{
                        'selected-chat': mail.selected
                    }"
                    class="message-list-item"
                    @click="openEmailChain(mail)"
                >
                    <img :src="fetchImage(mail)" class="profile-avatar" alt="avt" />
                    <div class="item-content">
                        <div class="content-top">
                            <p :style="mail.selected ? { color: '#CDEB09' } : {}" class="name">
                                {{ fetchChatPartnerName(mail) }}
                            </p>
                            <p class="time">
                                {{ lastMessageTime(mail.created_at) }}
                            </p>
                        </div>
                        <p class="content-bottom" v-html="mail.message">
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showMessageField" class="message-area">
            <div class="message-area-header">
                <div class="profile-info">
                    <button
                        v-if="!hideMobileElement"
                        @click="backToMessageList"
                        class="back-btn"
                    >
                        <img src="/images/icons/prev.svg" alt="goBack" />
                    </button>
                    <img class="profile-avatar" :src="fetchImage(selectedMail)" alt="artist img" />
                    <p class="profile-name">
                        {{ fetchSenderName(sender) }}
                    </p>
                </div>
                <button v-if="relevant_opportunity" class="archive-btn" @click="opportunity">
                    Go To Opportunity
                </button>
            </div>
            <div class="message-area-content">
                <Transition name="slide">
                    <div ref="messages" v-if="!showAllMail" class="messages">
                        <div v-for="(mail, index) in chainMails" :key="index" class="message">
                            <img
                                v-if="hideMobileElement"
                                :src="mail.sender.path || '/images/default-avatar.png'"
                                class="profile-avatar"
                                alt="message img"
                            />
                            <div class="message-content-info">
                                <div class="message-info">
                                    <p
                                        :style="
                                            mail.sender_id !== authUser.id
                                                ? { color: '#CDEB09' }
                                                : {}
                                        "
                                        class="info"
                                    >
                                        {{ messageName(mail) }}
                                    </p>
                                    <p class="time-stamp">
                                        {{ lastMessageTime(mail.created_at) }}
                                    </p>
                                </div>

                                <p class="message-content" v-html="mail.message"></p>
                            </div>
                        </div>
                    </div>
                </Transition>
                <div class="send-box-container">
                    <textarea
                        ref="messageArea"
                        class="message-area"
                        v-model="mail.message"
                        :class="{
                            'is-invalid': errors.message
                        }"
                        name="message"
                        placeholder="Reply"
                    ></textarea>
                    <button
                        :style="
                            !mail.message || !mail.message.length
                                ? { background: '#464646', color: '#262626' }
                                : {}
                        "
                        :disabled="!mail.message || !mail.message.length"
                        @click="sendEmail"
                        class="send-btn"
                    >
                        Send
                    </button>
                    <span v-if="errors.message" class="invalid-feedback" role="alert">
                        <strong>{{ errors.message[0] }}</strong>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import moment from 'moment'
    import goBack from '../../../../../public/images/icons/home_prev_slide.svg'
    import clip from '../../../../../public/images/clip.png'

    export default {
        name: 'index-old',
        props: ['authUser'],
        data() {
            return {
                url: '/api/profile/mail-chat',
                relevant_opportunity: null,
                moment: moment,
                form: new FormData(),
                mails: [],
                chainMails: [],
                sender: {},
                user: this.authUser,
                file: {},
                errors: {},
                showAllMail: true,
                mail: {
                    recipient_id: null,
                    message: null
                },
                goBack: goBack,
                clip: clip,
                path_image: '../../../../../images/icons/type-file/',
                messageField: false,
                filterBy: ['Unread messages', 'All messages'],
                allMails: [],
                showFilters: false,
                hideEmailUserList: false,
                width: null,
                filterByValue: '',
                showFilterContainer: false,
                userInfo: {},
                scrollTimeout: null,
                selectedMail: null
            }
        },
        setup() {
            const messages = ref(null)
            const messageArea = ref(null)
            return { messages, messageArea }
        },
        mounted() {
            this.updateWidth()
            window.addEventListener('resize', this.updateWidth)
            window.addEventListener('storage', this.handleStorageEvent)

            this.getMails().then(() => {
                const recipient_id = sessionStorage.getItem('recipient_id')
                if (recipient_id && !this.selectedMail) {
                    this.chatSelected(recipient_id)
                }
            });
        },
        methods: {
            handleStorageEvent(event) {
                if (event.key === 'recipient_id') {
                    const recipient_id = sessionStorage.getItem('recipient_id')
                    if (recipient_id) {
                        this.chatSelected(recipient_id)
                    }
                }
            },
            async fetchUserInfo() {
                const response = await axios.get('/api/profile/v1/settings/user')
                this.userInfo = response.data.data[0]
            },
            backToMessageList() {
                this.allMails.forEach((mail) => (mail.selected = false))
                this.messageField = false
            },
            openEmailChain(mail) {
                this.showAllMail = true

                this.allMails.forEach((mail) => (mail.selected = false))
                mail.selected = true

                const mailSender = mail.sender.id
                mailSender === this.userInfo.id
                    ? this.getChainMails(mail.recipient, mail)
                    : this.getChainMails(mail.sender, mail)
            },

            chatSelected(recipient_id) {
                if (this.selectedMail) {
                    return;
                }

                const existingMail = this.allMails.findLast(
                    (mail) =>
                        mail.sender.id === parseInt(recipient_id) ||
                        mail.recipient.id === parseInt(recipient_id)
                )
                if (existingMail) {
                    this.existingChatSelected(existingMail);
                } else {
                    this.newChatSelected(recipient_id);
                }
            },

            existingChatSelected(existingMail) {
                if (this.userInfo.id === existingMail.sender.id) {
                    this.mail.recipient_id = existingMail.sender.id
                    this.getChainMails(existingMail.recipient, existingMail)
                } else {
                    this.mail.recipient_id = existingMail.recipient.id
                    this.getChainMails(existingMail.sender, existingMail)
                }
            },

            newChatSelected(recipient_id) {
                this.mail.recipient_id = recipient_id
                this.getChainMails(null, { id: null, recipient: { id: recipient_id } })
            },

            fetchSenderName(user) {
                return user?.id !== this.authUser?.id
                    ? user?.first_name
                    : this.selectedMail?.sender?.id === this.authUser?.id
                        ? this.selectedMail?.recipient?.first_name
                        : this.selectedMail?.sender?.first_name;
            },
            fetchImage(mail) {
                if (!mail) {
                    return '/images/default-avatar.png'
                }

                if (this.allMails.includes(mail)) {
                    return mail.sender?.id !== this.authUser?.id
                        ? mail.sender?.path ?? '/images/default-avatar.png'
                        : mail.recipient?.path ?? '/images/default-avatar.png'
                }

                return mail.sender?.id === this.authUser?.id
                    ? mail.recipient?.path ?? '/images/default-avatar.png'
                    : mail.sender?.path ?? '/images/default-avatar.png'
            },

            fetchChatPartnerName(mail) {
                if (!mail) return "Unknown";

                return mail.sender?.id === this.authUser?.id
                    ? mail.recipient?.first_name ?? "Unknown"
                    : mail.sender?.first_name ?? "Unknown";
            },

            async getMails() {
                let vm = this

                try {
                    const response = await axios.get(vm.url + '/mails')

                    this.mails = response.data.data
                    this.allMails = response.data.data

                    let userIds = []

                    function idCheck(item) {
                        if (
                            userIds.indexOf(item.sender.id) === -1 ||
                            userIds.indexOf(item.recipient.id) === -1
                        ) {
                            userIds.push(item.sender.id)
                            userIds.push(item.recipient.id)
                            return true
                        }
                        return false
                    }

                    this.allMails = this.allMails.filter((item) => idCheck(item))
                    userIds = []
                    this.mails = this.mails.filter((item) => idCheck(item))

                    this.allMails.forEach((mail) => {
                        this.$set(mail, 'selected', false)
                    })

                    return Promise.resolve()
                } catch (error) {
                    console.error('Error fetching mails:', error);
                }
            },

            getChainMails(sender, mail) {
                this.selectedMail = mail
                let vm = this
                this.messageField = true
                this.hideEmailUserList = true
                vm.sender = sender ? sender : {}

                $('.js-show-loading').show()
                showPreloaderDiv()

                const recipientId =
                    (mail.sender && this.userInfo.id === mail.sender.id && mail.sender.id) ||
                    (mail.recipient && mail.recipient.id) ||
                    'unknown-recipient';

                const senderSegment = sender && sender.id ? `/${sender.id}` : '';
                const mailIdSegment = mail && mail.id ? `/${mail.id}` : '';
                const constructedUrl = `${vm.url}/chain-mails/${recipientId}${senderSegment}${mailIdSegment}`;

                axios
                    .get(constructedUrl)
                    .then(function (response) {
                        $('.js-show-loading').hide()
                        hidePreloaderDiv()
                        vm.getCountNewEmail()
                        let data = response.data.data
                        vm.relevant_opportunity = response.data.relevant_opportunity ?? null;

                        if (!Array.isArray(data)) {
                            vm.loadNewMessage(data)
                        } else {
                            vm.chainMails = data
                            if (data[0]['sender_id'] == sender.id) {
                                vm.mail.recipient_id = data[0]['sender_id']
                            } else {
                                vm.mail.recipient_id = data[0]['recipient_id']
                            }
                            vm.getRespondTime(vm.mail)
                            vm.$nextTick(() => {
                                vm.showAllMail = false
                            })
                        }
                    })
            },

            getCountNewEmail() {
                let vm = this
                axios.get(vm.url + '/count/new-mails').then(function (response) {
                    let newEmail = response.data,
                        divNewEmail = $('.mail-new-count')
                    divNewEmail.text(response.data)
                    if (newEmail === 0) {
                        divNewEmail.hide()
                    }
                })
            },

            getRespondTime(data) {
                let vm = this
                axios
                    .get(vm.url + '/respond-time/' + data.recipient_id)
                    .then(function (response) {
                        let respondTimeText = $('#respond-time')
                        respondTimeText.text(response.data)
                    })
            },

            sendEmail() {
                let vm = this
                vm.errors = []
                showPreloaderDiv()
                _.each(vm.mail, (value, key) => {
                    if (value) {
                        vm.form.append(key, value)
                    }
                })
                showPreloader()
                axios
                    .post(vm.url, vm.form)
                    .then(function (response) {
                        let data = response.data
                        const mailSender = data.mail.sender.id
                        mailSender === vm.userInfo.id
                            ? vm.getChainMails(data.mail.recipient, data.mail)
                            : vm.getChainMails(data.mail.sender, data.mail)
                        vm.getMails()
                        vm.resetMail()
                        vm.resetForm()
                        vm.resetFiles()
                        hidePreloader()
                        hidePreloaderDiv()
                    })
                    .catch(function (response) {
                        hidePreloader()
                        hidePreloaderDiv()

                        let error = response.response.data

                        // ensure all error types have msg displayed
                        if (error.errors) {
                            vm.errors = error.errors
                        } else {
                            let systemErr = { message: [error.message] }
                            vm.errors = systemErr
                        }
                    })
            },
            opportunity() {
                if (this.relevant_opportunity?.path) {
                    window.open(this.relevant_opportunity.path, '_blank')
                }
            },

            fileChange() {
                let vm = this
                let listFile = []
                let key = 0
                vm.resetFiles()
                _.each(this.$refs.file.files, (value) => {
                    if (value) {
                        let name = value.name
                        let type = name.substring(name.indexOf('.') + 1)
                        if (value.size > 15728640) {
                            $('.error-file').text(
                                'You can download files not bigger than 15 mb'
                            )
                        } else if (!vm.validationFile(type)) {
                            $('.error-file').text('This file type cannot be loaded')
                        } else {
                            let icon = vm.icon(type)
                            listFile[key] =
                                '<div class="me-2">' +
                                '<img src="' +
                                icon +
                                '" alt="icon" width="18px" height="21px">' +
                                '<span>' +
                                name +
                                '</span>' +
                                '</div>'
                            key++
                            vm.form.append('attachments[]', value)
                        }
                    }
                })
                $('.name-files').html(listFile)
            },

            returnBack() {
                this.getMails()
                this.resetForm()
                this.resetMail()
                this.resetFiles()
                this.resetChainMails()
                this.errors = []
                this.showAllMail = true
                this.hideEmailUserList = false
                this.messageField = false

                sessionStorage.removeItem('recipient_id')
            },

            image(file) {
                let vm = this
                let name = file.name_file
                let type = name.substring(name.indexOf('.') + 1)

                return vm.icon(type)
            },

            icon(type) {
                let vm = this
                let icon = ''
                switch (type) {
                    case 'csv':
                        icon = 'csv'
                        break
                    case 'docx':
                        icon = 'docs'
                        break
                    case 'jpg':
                        icon = 'jpg'
                        break
                    case 'png':
                        icon = 'jpg'
                        break
                    case 'mp4':
                        icon = 'mp4'
                        break
                    case 'pdf':
                        icon = 'pdf'
                        break
                    case 'ppt':
                        icon = 'ppt'
                        break
                    case 'xls':
                        icon = 'xls'
                        break
                    case 'xlsx':
                        icon = 'xls'
                        break
                    default:
                        icon = 'file'
                        break
                }
                return vm.path_image + icon + '.png'
            },

            resetMail() {
                this.mail = {
                    recipient_id: null,
                    message: null
                }
            },

            resetChainMails() {
                this.chainMails = []
            },

            resetForm() {
                this.form = new FormData()
            },

            resetFiles() {
                $('.error-file').text('')
                $('.name-files').empty()
            },

            validationFile(type) {
                let result = false
                switch (type) {
                    case 'xlsx':
                        result = true
                        break
                    case 'doc':
                        result = true
                        break
                    case 'docx':
                        result = true
                        break
                    case 'ppt':
                        result = true
                        break
                    case 'pdf':
                        result = true
                        break
                    case 'pptx':
                        result = true
                        break
                    case 'txt':
                        result = true
                        break
                    case 'csv':
                        result = true
                        break
                    case 'xls':
                        result = true
                        break
                    case 'mp4':
                        result = true
                        break
                    case 'mp3':
                        result = true
                        break
                    case 'giv':
                        result = true
                        break
                    case 'jpeg':
                        result = true
                        break
                    case 'png':
                        result = true
                        break
                    case 'jpg':
                        result = true
                        break
                    case 'webm':
                        result = true
                        break
                    case 'flv':
                        result = true
                        break
                    case 'avi':
                        result = true
                        break
                    case 'mng':
                        result = true
                        break
                    case 'svg':
                        result = true
                        break
                    case 'm4v':
                        result = true
                        break
                    case 'amv':
                        result = true
                        break
                    default:
                        result = true
                        break
                }
                return result
            },
            filterMessages() {
                if (!this.showFilterContainer) {
                    this.showFilterContainer = true
                } else {
                    this.showFilterContainer = false
                }
            },
            getFilterByValue(filterName) {
                this.filterByValue = filterName
                if (this.filterByValue === 'Unread messages') {
                    this.allMails = this.mails.filter((item) => item.status === 0)
                    this.showFilterContainer = false
                } else if (this.filterByValue === 'All messages') {
                    this.showFilterContainer = false
                    this.allMails = this.mails
                }
            },
            activeFilter() {
                if (!this.showFilters) {
                    this.showFilters = true
                }
            },
            updateWidth() {
                this.width = window.innerWidth
            },
            loadNewMessage(sender) {
                this.sender = sender
                this.$nextTick(() => {
                    this.showAllMail = false
                    this.messageField = true
                })
            }
        },
        computed: {
            hideMobileElement() {
                return this.width && this.width < 600 ? false : true
            },
            showMessageList() {
                return this.width && this.width < 600 ? !this.messageField : true
            },
            showMessageField() {
                if (!Object.keys(this.sender).length) return false
                return this.width && this.width < 600 ? this.messageField : true
            },
            allMessages() {
                let userIds = []

                function idCheck(item) {
                    if (
                        userIds.indexOf(item.sender.id) === -1 ||
                        userIds.indexOf(item.recipient.id) === -1
                    ) {
                        userIds.push(item.sender.id)
                        userIds.push(item.recipient.id)
                        return true
                    }
                    return false
                }

                return this.allMails.filter((item) => idCheck(item))
            },
            getIcon() {
                return '/images/'
            },
            lastMessageTime() {
                return (createdAt) => {
                    const messageTime = moment(createdAt)
                    const timeNow = moment()
                    const time5MinAgo = moment().subtract(5, 'minutes')

                    if (messageTime.isBetween(time5MinAgo, timeNow)) {
                        return 'Just Now'
                    } else if (!messageTime.isSame(new Date(), 'day')) {
                        return messageTime.format('MM/DD/YYYY')
                    } else {
                        return messageTime.format('h:mm a')
                    }
                }
            },
            messageName(self) {
                return (mail) => {
                    if (mail.sender_id === self.authUser.id) {
                        return 'You'
                    } else {
                        return mail.sender.first_name
                    }
                }
            }
        },
        watch: {
            messages: {
                handler: function (ref) {
                    if (ref) {
                        this.scrollTimeout = setTimeout(() => {
                            ref.lastChild.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'nearest'
                            })
                        }, 1000)
                    }

                    if (this.messageArea) {
                        this.messageArea.focus()
                    }
                },
                immediate: true
            }
        },
        async created() {
            window.addEventListener('resize', this.updateWidth)
            this.updateWidth()
            await this.fetchUserInfo()
        },
        beforeDestroy() {
            clearTimeout(this.scrollTimeout)
            window.removeEventListener('resize', this.updateWidth)
            window.removeEventListener('storage', this.handleStorageEvent)
        }
    }

    function showPreloaderDiv() {
        $('.js-preloader').addClass('preloader-div')
        $('.js-textarea-send').attr('readonly', true)
    }

    function hidePreloaderDiv() {
        $('.js-preloader').removeClass('preloader-div')
        $('.js-textarea-send').attr('readonly', false)
    }

    function showPreloader() {
        $('.preloader').addClass('active')
    }

    function hidePreloader() {
        $('.preloader').removeClass('active')
    }

    //Filter
    $(document).on('keyup', '#email-search', function (e) {
        let value = $(this).val().toLowerCase(),
            emailList = $('#email-search').closest('.email-list'),
            emailUserList = emailList.find('.email-user-list'),
            noResults = emailUserList.find('.no-results')
        if (value !== '') {
            emailList.find('.email-media-list li').filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            })
            let tblRow = emailUserList.find('.email-media-list li:visible').length

            if (tblRow === 0) {
                noResults.addClass('show')
                noResults.animate({ scrollTop: '0' }, 500)
            } else {
                if (noResults.hasClass('show')) {
                    noResults.removeClass('show')
                }
            }
        } else {
            emailUserList.find('.email-media-list li').show()
            if (noResults.hasClass('show')) {
                noResults.removeClass('show')
            }
        }
    })
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    @media (max-width: 1000px) {
        .messages {
            max-height: 300px !important;
        }
        .send-box-container {
            flex-direction: column !important;
            padding-right: 16px;
        }
    }
    @media (max-width: 600px) {
        .mail-chat-container {
            background: none !important;
            .message-list {
                max-width: 100% !important;
                border-right: none !important;

                .message-list-header {
                    .message-title {
                        font-size: 26px !important;
                    }
                    .filter-box {
                        left: 30% !important;
                    }

                    .message-list-content {
                        padding: 8px !important;
                    }
                }
            }
            .message-area {
                .message-area-header {
                    .profile-info {
                        gap: 8px !important;
                    }
                }
                .message-area-content {
                    .messages {
                        border-top: 1px solid #8b8b8b;

                        .message {
                            padding: 8px !important;
                        }
                    }
                }
            }
        }
    }
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .profile-avatar {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border-radius: 48px;
    }
    .mail-chat-container {
        overflow-x: hidden;
        display: flex;
        max-width: 1048px;
        height: 600px;
        width: 100%;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 20px;
        border-radius: 16px;
        background: #262626;

        .message-list {
            max-width: 335px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 0px;
            border-right: 1px solid #464646;
            height: 100%;

            .message-list-header {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 8px;
                padding: 16px 24px;

                .message-title {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 44px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 110%;
                    letter-spacing: -1.76px;
                }
                .filter-icon {
                    position: relative;
                }
                .filter-box {
                    max-width: 162px;
                    position: absolute;
                    top: 65%;
                    left: 68%;
                    background: #262626;
                    border: 1px solid #acacac;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    z-index: 9999;
                    width: 100%;

                    .filter-option {
                        width: 100%;
                        padding: 8px 16px;
                        color: #8b8b8b;
                        font-family: 'Instrument Sans';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 115%;
                        letter-spacing: 0.14px;
                        cursor: pointer;
                        text-wrap: nowrap;
                    }
                    .select-filter {
                        color: #f5f5f5;
                    }
                }
            }
            .message-list-content {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 8px;
                padding: 16px;

                .selected-chat {
                    border-top: none !important;
                    border-radius: 8px;
                    background: #333;
                }
                .message-list-item {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 8px;
                    padding: 8px;
                    border-top: 1px solid #464646;
                    cursor: pointer;

                    .item-content {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        gap: 4px;

                        .content-top {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;

                            .name {
                                max-width: 158px;
                                overflow: hidden;
                                color: #dedede;
                                text-overflow: ellipsis;
                                font-family: 'Instrument Sans';
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 115%;
                                letter-spacing: 0.14px;
                            }
                            .time {
                                text-wrap: nowrap;
                                overflow: hidden;
                                color: #acacac;
                                text-align: right;
                                text-overflow: ellipsis;
                                font-family: 'Instrument Sans';
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 115%;
                                letter-spacing: 0.14px;
                            }
                        }
                        .content-bottom {
                            max-width: 231px;
                            overflow: hidden;
                            color: #acacac;
                            text-overflow: ellipsis;
                            font-family: 'Instrument Sans';
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 115%;
                            letter-spacing: 0.14px;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
        .message-area {
            width: 100%;
            height: 100%;
            max-width: 693px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;

            .message-area-header {
                width: 100%;
                display: flex;
                flex-direction: row;
                gap: 16px;
                align-items: center;
                padding-top: 24px;

                .profile-info {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 16px;

                    .profile-name {
                        color: #cdeb09;
                        font-family: 'Instrument Sans';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 125%;
                    }
                    .back-btn {
                        padding: 8px;
                        img {
                            width: 16px;
                            height: 16px;
                        }
                    }
                }
                .archive-btn {
                    background: none;
                    padding: 10px 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 125%;
                    margin-left: auto;
                }
            }
            .message-area-content {
                width: 100%;

                .messages::-webkit-scrollbar {
                    width: 8px;
                }
                .messages::-webkit-scrollbar-track {
                    background-color: none;
                }
                .messages::-webkit-scrollbar-thumb {
                    max-height: 64px;
                    border-radius: 8px;
                    background: #8b8b8b;
                }
                @keyframes slide {
                    0% {
                        transform: translateX(700px);
                        overflow-y: hidden;
                    }
                    10% {
                        transform: translateX(630px);
                        overflow-y: hidden;
                    }
                    20% {
                        transform: translateX(560px);
                        overflow-y: hidden;
                    }
                    30% {
                        transform: translateX(490px);
                        overflow-y: hidden;
                    }
                    40% {
                        transform: translateX(420px);
                        overflow-y: hidden;
                    }
                    50% {
                        transform: translateX(350px);
                        overflow-y: hidden;
                    }
                    60% {
                        transform: translateX(280px);
                        overflow-y: hidden;
                    }
                    70% {
                        transform: translateX(210px);
                        overflow-y: hidden;
                    }
                    80% {
                        transform: translateX(140px);
                        overflow-y: hidden;
                    }
                    90% {
                        transform: translateX(70px);
                        overflow-y: hidden;
                    }
                    100% {
                        transform: translateX(0px);
                        overflow-y: scroll;
                    }
                }
                .slide-enter-active {
                    animation-name: slide;
                    animation-duration: 0.3s;
                    animation-fill-mode: forwards;
                    animation-timing-function: linear;
                }
                .messages {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: safe flex-end;
                    gap: 8px;
                    padding: 0px 16px 16px 0px;
                    max-height: 368px;
                    height: 100%;
                    overflow-y: auto;
                    margin-top: 8px;

                    .message {
                        padding: 16px;
                        border-radius: 16px;
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 16px;
                        border-radius: 16px;
                        background: #333;

                        .profile-avatar {
                        }
                        .message-content-info {
                            max-width: 565px;
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;

                            .message-info {
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-start;
                                align-items: baseline;
                                flex-wrap: wrap;
                                gap: 16px;

                                .info {
                                    color: #dedede;
                                    font-family: 'Instrument Sans';
                                    font-size: 14px;
                                    font-style: normal;
                                    font-weight: 500;
                                    line-height: 115%;
                                    letter-spacing: 0.14px;
                                }
                                .time-stamp {
                                    color: #acacac;
                                    font-family: 'Instrument Sans';
                                    font-size: 14px;
                                    font-style: normal;
                                    font-weight: 500;
                                    line-height: 115%;
                                    letter-spacing: 0.14px;
                                }
                            }
                            .message-content {
                                color: #dedede;
                                font-family: 'Instrument Sans';
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 125%;
                                width: 100%;
                                white-space: pre-line;
                                word-break: break-word;
                            }
                        }
                    }
                }
                .send-box-container {
                    display: flex;
                    padding: 16px 0px;
                    align-items: flex-end;
                    gap: 11px;
                    max-width: 675px;
                    width: 100%;

                    .message-area {
                        border-radius: 8px;
                        border: 1px solid #8b8b8b;
                        padding: 10px 12px;
                        color: #dedede;
                        font-family: 'Instrument Sans';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 125%;
                        background: none;
                        resize: none;
                        height: 120px;
                    }
                    .message-area::placeholder {
                        color: #646464;
                        font-family: 'Instrument Sans';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 125%;
                    }
                    .send-btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        align-self: flex-end;
                        border-radius: 120px;
                        background: #cdeb09;
                        padding: 12px 32px;
                    }
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .not-message {
        color: #dedede;
    }
    .wrapper-textarea {
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: center;
    }
    .email-media-list {
        max-width: 352px;
    }
    .user-info {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .user-info p {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .archive-btn {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .archive-btn p {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .email-attachement {
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        width: 42px;
        padding: 20px 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .invisible-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: black;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        border: 0;
    }

    .email-list {
        flex: 40%;
        max-height: 1100px;
        width: 50%;
    }

    .email-application .email-app-details {
        position: inherit;
        background-color: #f8f8f8;
        height: 100%;
        flex: 70%;
        width: 50%;
    }

    .message-field {
        flex: 70%;
        margin-top: 32px;
    }

    .email-user-list {
        overflow-x: auto;
    }

    .selected-container {
        background: #f5f5f7;
        border: 1px solid #f5f5f7;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        left: 200px;
        padding: 5px;
        position: absolute;
        top: 27px;
        z-index: 9999;
        width: max-content;
    }

    .selected-container p {
        margin-bottom: 0px;
        cursor: pointer;
    }
    .selected-container p:hover {
        text-decoration: underline;
    }

    .fa-filter {
        color: white;
        cursor: pointer;
        margin-top: 10px !important;
        margin-left: 15px;
    }

    .message-text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .archive-icon {
        background: url('/images/744726.png');
        background-size: contain;
        background-repeat: no-repeat;
    }

    @media (max-width: 1200px) {
        .email-list {
            width: 100%;
        }

        .email-application .email-app-details {
            width: 100%;
        }
    }

    @media (min-width: 1200px) and (max-width: 1500px) {
        .message-box-read .box-info {
            width: 50%;
        }
    }

    @media (min-width: 767px) and (max-width: 859px) {
        .email-application {
            padding-left: 0px !important;
            padding-right: 0px !important;
        }

        .message-list-box {
            padding: 20px 10px !important;
        }
    }

    @media (max-width: 600px) {
        .wrapper-textarea {
            flex-direction: column;
        }
    }
</style>
